"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SnakeToSpace = function SnakeToSpace() {
  return function (input, param) {
    if (angular.isDefined(input)) {
      return input.replace(/_/g, " ").toLowerCase();
    }
  };
};
exports.default = SnakeToSpace;


// WEBPACK FOOTER //
// ./client/app/common/filters/snakeToSpaceService/snakeToSpace.filter.js